export default [
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('@/views/components/campaign/calendar/Calendar.vue'),
  },
]
